"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItem = exports.Type = exports.Severity = exports.Status = void 0;
var React = require("react");
var react_timeago_1 = require("react-timeago");
var ApWidgetIcon_1 = require("../ApWidgets/ApWidgetIcon");
var NotificationItem_styles_1 = require("./NotificationItem.styles");
var ARCHIVE_ACTION_NAME = 'Dismiss';
var Status;
(function (Status) {
    Status["read"] = "Read";
    Status["unread"] = "Unread";
    Status["archived"] = "Archived";
})(Status = exports.Status || (exports.Status = {}));
var Severity;
(function (Severity) {
    Severity["important"] = "Important";
    Severity["info"] = "Information";
})(Severity = exports.Severity || (exports.Severity = {}));
var Type;
(function (Type) {
    Type["action"] = "Actionable";
    Type["normal"] = "Normal";
})(Type = exports.Type || (exports.Type = {}));
var openLink = function (url) {
    var win = window.open(url, '_blank');
    if (win) {
        win.focus();
    }
};
exports.NotificationItem = function (_a) {
    var data = _a.data, className = _a.className, archive = _a.archive;
    var itemData = {
        actions: __spread((data.payload.url && data.payload.actionVerb
            ? [
                {
                    action: function () { return openLink(data.payload.url); },
                    name: data.payload.actionVerb,
                },
            ]
            : []), (data.type === Type.normal
            ? [
                {
                    action: function () { return archive(data.notificationId); },
                    name: ARCHIVE_ACTION_NAME,
                },
            ]
            : [])),
        content: data.payload.content,
        isNew: data.state === Status.unread,
        moduleName: data.payload.shortName,
        severity: data.payload.severity,
        timestamp: data.payload.timestamp,
    };
    return (React.createElement(NotificationItem_styles_1.Wrapper, { isNew: itemData.isNew, important: itemData.severity === Severity.important, className: "ap-notification-item " + (className ? className : '') },
        React.createElement(NotificationItem_styles_1.Section, null, itemData.moduleName && (React.createElement(ApWidgetIcon_1.ApWidgetIcon, { type: itemData.moduleName.toLowerCase() }))),
        React.createElement(NotificationItem_styles_1.Section, null,
            React.createElement(NotificationItem_styles_1.Text, null, itemData.content),
            React.createElement(NotificationItem_styles_1.Actions, null,
                itemData.actions &&
                    itemData.actions.map(function (_a, index) {
                        var name = _a.name, action = _a.action;
                        return (React.createElement(NotificationItem_styles_1.StyledButton, { key: index, onClick: action }, name));
                    }),
                React.createElement(NotificationItem_styles_1.Timestamp, null,
                    React.createElement(react_timeago_1.default, { minPeriod: 60, date: itemData.timestamp }))))));
};
//# sourceMappingURL=NotificationItem.js.map